import React from 'react'
import { withStyles, Container, Grid, Typography, Link } from '@material-ui/core'
import { Link as ReactLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons'

const styles = theme => ({
    root: {
        backgroundColor: "#1a1a1a",
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
        color: "#fff",
        marginTop: theme.spacing(4)
    },
    title: {
        marginBottom: theme.spacing(4)
    },
    item: {
        marginBottom: theme.spacing(1),
        '&>*': {
            color: "#fff"
        }
    },
    iconsContainer: {
        listStyle: 'none',
        padding: 0,
        '&>*': {
            display: 'inline-block',
            marginRight: theme.spacing(6),
            '&:last-child': {
                marginRight: 0
            }
        }
    },
    icon: {
        fontSize: 35,
        color: "#fff",

    },
    copyright: {
        marginTop: theme.spacing(2)
    }
})

class Footer extends React.Component {
    render() {
        const { classes } = this.props
        return (
            <footer className={classes.root}>
                <Container>
                    <Grid container spacing={2}>
                        <Grid item md={6} sm={12}>
                            <Typography variant="h4" className={classes.title}>Pages</Typography>
                            <ul>
                                <li className={classes.item}>
                                    <Link component={ReactLink} to="/">Home</Link>
                                </li>
                                <li className={classes.item}>
                                    <Link component={ReactLink} to="/articles">Articles</Link>
                                </li>
                                <li className={classes.item}>
                                    <Link component={ReactLink} to="/about">About Us</Link>
                                </li>
                                <li className={classes.item}>
                                    <Link component={ReactLink} to="/staff">Staff</Link>
                                </li>
                                <li className={classes.item}>
                                    <Link component={ReactLink} to="/contact">Contact Us</Link>
                                </li>
                            </ul>
                        </Grid>
                        <Grid item md={6} sm={12}>
                            <Typography variant="h4" className={classes.title}>Find Us On</Typography>
                            <ul className={classes.iconsContainer}>
                                <li>
                                    <Link component="a" target="_blank" href="https://www.facebook.com/buespesc/">
                                        <FontAwesomeIcon className={classes.icon} icon={faFacebook} />
                                    </Link>
                                </li>
                                <li>
                                    <Link component="a" target="_blank" href="https://twitter.com/spe_buesc">
                                        <FontAwesomeIcon className={classes.icon} icon={faTwitter} />
                                    </Link>
                                </li>
                                <li>
                                    <Link component="a" target="_blank" href="https://www.instagram.com/bue.spe/">
                                        <FontAwesomeIcon className={classes.icon} icon={faInstagram} />
                                    </Link>
                                </li>
                                <li>
                                    <Link component="a" target="_blank" href="https://www.youtube.com/channel/UCXYIM9-Dv3gRbPixvPvh9Iw">
                                        <FontAwesomeIcon className={classes.icon} icon={faYoutube} />
                                    </Link>
                                </li>
                            </ul>
                        </Grid>
                    </Grid>
                    <Typography className={classes.copyright}>&copy;2020 SPE BUE</Typography>
                </Container>
            </footer>
        )
    }
}

export default withStyles(styles)(Footer)